import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import useGetUserProfile from '../../../common/category/useGetUserProfile'
import { Element } from '../../../common/html/element'
import { PAYMENT_METHOD } from '../../constant'
import { checkFullDataBlock } from '../../helper'
import classes from '../../index.module.scss'
import {
  selectBusinessCreditReportId,
  selectCheckIds,
  selectFactSheetData,
  selectFactSheetId,
} from '../../store/slice'
import { BankTransfer } from './methodPayment/BankTransfer'
import { Card } from './methodPayment/Card'
import { Package } from './methodPayment/Package'
import { PostPaid } from './methodPayment/PostPaid'

const PaymentMethod = ({
  method,
  setMethod,
  bankTransferType,
  setBankTransferType,
  isScreening,
  unitBank,
  setUnitBank,
  isShowInvalidPackage,
}) => {
  const { loading } = useGetUserProfile()

  const idCheck = useSelector(selectCheckIds)
  const factSheetId = useSelector(selectFactSheetId)
  const factSheetIdCheck = factSheetId.filter((item) => idCheck.includes(item))
  const dataFactSheet = useSelector(selectFactSheetData)
  const businessCreditReportId = useSelector(selectBusinessCreditReportId)

  const businessCreditReportIdCheck = businessCreditReportId.filter((item) =>
    idCheck.includes(item),
  )
  const isFullDataBlock = checkFullDataBlock(dataFactSheet, factSheetIdCheck)
  const isHasFullDataBlock =
    checkFullDataBlock(dataFactSheet, factSheetIdCheck, true) ||
    !!businessCreditReportIdCheck.length

  return (
    <Element
      style={{
        borderBottom:
          method !== PAYMENT_METHOD.PACKAGE ? '5px solid #FFFFFF' : '',
      }}
      className={classes.paymentMethodContainer}
    >
      <Element className="fw600" style={{ fontSize: 14 }}>
        <Translate value="cartAndOrders.orderInformation.payMethod" />
      </Element>
      <div className="dFlex mt1">
        {Object.values(PAYMENT_METHOD).map((key) => {
          const isActive = method === key
          return (
            <Element
              key={key}
              className={classes.paymentTab}
              style={{
                border: isActive ? '1px solid #2C73E8' : undefined,
                color: isActive ? '#2C73E8' : undefined,
                fontSize: 14,
              }}
              onClick={() => setMethod(key)}
            >
              <Translate value={`cartAndOrders.payMethod.${key}`} />
              {isActive && (
                <Element
                  className={classes.triangle}
                  style={{
                    borderColor: 'transparent #2C73E8 transparent transparent',
                  }}
                />
              )}
            </Element>
          )
        })}
      </div>
      <div className="mt2">
        {method === PAYMENT_METHOD.PACKAGE && !loading && (
          <Package
            isScreening={isScreening}
            isShowInvalid={isShowInvalidPackage}
            isShowNotFullDataBlock={isFullDataBlock}
            isBothFullAndNotFullDataBlock={
              isFullDataBlock && isHasFullDataBlock
            }
          />
        )}
        {method === PAYMENT_METHOD.CARD && (
          <Card
            bankTransferType={bankTransferType}
            setBankTransferType={setBankTransferType}
          />
        )}
        {method === PAYMENT_METHOD.POST_PAID && (
          <PostPaid isBlock={!factSheetIdCheck.length && !isScreening} />
        )}
        {method === PAYMENT_METHOD.BANK_TRANSFERS && (
          <BankTransfer unitBank={unitBank} setUnitBank={setUnitBank} />
        )}
      </div>
    </Element>
  )
}

export default PaymentMethod
